import { ScreenshotSetting } from "components/screenshot/components";
import {
  ControlContext,
  ControlDef,
  SettingsControl,
  filterVisible
} from "components/screenshot/models/controlDefinition";

/** Render the appropriate input element for a control definition. */
const renderInput = (def: ControlDef): JSX.Element => {
  const { input } = def;
  switch (input.type) {
    case "number":
      return (
        <ScreenshotSetting.Input
          type="number"
          unit={input.unit}
          min={input.min}
          max={input.max}
          step={input.step}
        />
      );
    case "boolean":
      return <ScreenshotSetting.Input type="boolean" />;
    case "text":
      return <ScreenshotSetting.Input type="text" />;
  }
};

/** Convert a ControlDef into a renderable SettingsControl. */
const toSettingsControl = (def: ControlDef): SettingsControl => ({
  group: def.group,
  control: (
    <ScreenshotSetting.Item
      key={def.name}
      name={def.name}
      label={def.label}
      immediate={def.input.type === "boolean" || !!def.renderChild}
      valuePropName={
        def.valuePropName ?? (def.input.type === "boolean" ? "checked" : undefined)
      }>
      {def.renderChild ? def.renderChild() : renderInput(def)}
    </ScreenshotSetting.Item>
  )
});

/**
 * FP pipeline: filter definitions by visibility → map to rendered controls.
 *
 * @example
 * const controls = buildControls(MPC_CONTROLS, { isDashboard: true });
 */
export const buildControls = (
  defs: readonly ControlDef[],
  ctx: ControlContext
): SettingsControl[] => filterVisible(defs, ctx).map(toSettingsControl);
